export const nanobarOptions = {
  classname: "nanobar",
  id: "nanobar",
};
